import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      title: "Limpeza Profissional",
      description: "Serviços completos de limpeza e conservação para ambientes corporativos, com equipe treinada e produtos de qualidade. Atendemos escritórios, indústrias, comércios e condomínios.",
      icon: "🧹"
    },
    {
      title: "Manutenção Predial",
      description: "Manutenção preventiva e corretiva para garantir o funcionamento adequado das instalações da sua empresa. Serviços elétricos, hidráulicos, pintura, alvenaria e muito mais.",
      icon: "🔧"
    },
    {
      title: "Segurança Patrimonial",
      description: "Proteção do patrimônio físico e humano da sua empresa, com profissionais qualificados e tecnologia avançada. Vigilância, controle de acesso e monitoramento.",
      icon: "🛡️"
    },
    {
      title: "Recepção e Portaria",
      description: "Profissionais treinados para recepção, controle de acesso e atendimento ao público, garantindo a primeira impressão positiva da sua empresa.",
      icon: "👋"
    },
    {
      title: "Jardinagem",
      description: "Manutenção de áreas verdes, jardins e paisagismo, mantendo o ambiente externo da sua empresa sempre bonito e bem cuidado.",
      icon: "🌱"
    },
    {
      title: "Controle de Pragas",
      description: "Serviços de dedetização, desratização e controle de pragas urbanas, garantindo um ambiente saudável e livre de infestações.",
      icon: "🐜"
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gmax-dark-blue text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Nossos Serviços</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Oferecemos uma ampla gama de serviços de facilities para atender às necessidades específicas da sua empresa.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="card hover:border-gmax-blue hover:border-l-4 transition-all">
                <div className="text-4xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-bold mb-2 text-gmax-dark-blue">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Custom Solutions */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="section-title">Soluções Personalizadas</h2>
            <p className="text-gray-600 max-w-3xl mx-auto">
              Entendemos que cada empresa tem necessidades únicas. Por isso, oferecemos soluções personalizadas para atender às suas demandas específicas.
            </p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="flex flex-col md:flex-row items-center">
              <div className="md:w-2/3 mb-6 md:mb-0 md:pr-8">
                <h3 className="text-2xl font-bold mb-4 text-gmax-dark-blue">Como funciona?</h3>
                <ol className="space-y-4">
                  <li className="flex">
                    <span className="bg-gmax-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">1</span>
                    <p>Avaliamos as necessidades específicas da sua empresa através de uma visita técnica.</p>
                  </li>
                  <li className="flex">
                    <span className="bg-gmax-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">2</span>
                    <p>Elaboramos uma proposta personalizada com os serviços adequados ao seu negócio.</p>
                  </li>
                  <li className="flex">
                    <span className="bg-gmax-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">3</span>
                    <p>Selecionamos os profissionais mais qualificados do nosso banco de dados.</p>
                  </li>
                  <li className="flex">
                    <span className="bg-gmax-blue text-white rounded-full w-8 h-8 flex items-center justify-center mr-4 flex-shrink-0">4</span>
                    <p>Implementamos os serviços com acompanhamento constante e garantia de qualidade.</p>
                  </li>
                </ol>
              </div>
              <div className="md:w-1/3">
                <div className="bg-gmax-dark-blue text-white p-6 rounded-lg">
                  <h4 className="text-xl font-bold mb-4">Solicite um orçamento</h4>
                  <p className="mb-4">Entre em contato conosco para uma avaliação personalizada das necessidades da sua empresa.</p>
                  <Link to="/contato" className="btn-primary block text-center">Fale Conosco</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
